// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ModalFeedbackDone_modal_container__U6-uU {
    width: 560px;
    height: 494px;
}

.ModalFeedbackDone_modal_container__U6-uU .ant-modal-content {
    padding: 0 0 16px 0 !important;
}

.ModalFeedbackDone_main__rX00p {
    width: 100%;
    height: 100%;
    padding: 47px 52px 0 52px;
}

.ModalFeedbackDone_header__RuG9V,
.ModalFeedbackDone_section__I89yY {
    margin-bottom: 20px;
}

.ModalFeedbackDone_header_title__\\+CaWz {
    margin-bottom: 20px;
    font-size: 30px;
    font-weight: bold;
    color: #1F1F1F;
    text-align: center;
}

.ModalFeedbackDone_header_explain__IQBBB {
    font-size: 14px;
    color: #1f1f1f;
    text-align: center;
}

.ModalFeedbackDone_section__I89yY {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 250px;
}

.ModalFeedbackDone_img__FqK4c {
    width: 270px;
    height: 240px;
}

.ModalFeedbackDone_footer__oHYwh {
    width: 100%;
    height: 48px;
}
`, "",{"version":3,"sources":["webpack://./src/common/ModalFeedbackDone/index.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".modal_container {\n    width: 560px;\n    height: 494px;\n}\n\n.modal_container :global(.ant-modal-content) {\n    padding: 0 0 16px 0 !important;\n}\n\n.main {\n    width: 100%;\n    height: 100%;\n    padding: 47px 52px 0 52px;\n}\n\n.header,\n.section {\n    margin-bottom: 20px;\n}\n\n.header_title {\n    margin-bottom: 20px;\n    font-size: 30px;\n    font-weight: bold;\n    color: #1F1F1F;\n    text-align: center;\n}\n\n.header_explain {\n    font-size: 14px;\n    color: #1f1f1f;\n    text-align: center;\n}\n\n.section {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 250px;\n}\n\n.img {\n    width: 270px;\n    height: 240px;\n}\n\n.footer {\n    width: 100%;\n    height: 48px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal_container": `ModalFeedbackDone_modal_container__U6-uU`,
	"main": `ModalFeedbackDone_main__rX00p`,
	"header": `ModalFeedbackDone_header__RuG9V`,
	"section": `ModalFeedbackDone_section__I89yY`,
	"header_title": `ModalFeedbackDone_header_title__+CaWz`,
	"header_explain": `ModalFeedbackDone_header_explain__IQBBB`,
	"img": `ModalFeedbackDone_img__FqK4c`,
	"footer": `ModalFeedbackDone_footer__oHYwh`
};
export default ___CSS_LOADER_EXPORT___;
